import { styled } from '@mui/material';

import Header from '../Header';

export const DrawerHeader = styled(Header)(({ theme }) => ({
  padding: theme.spacing(5, 4),
}));
